export enum ProgramTypes {
  Default = 'Default',

  // New Offerings
  CorePrint = 'Core Print',
  PersonalSystems = 'Personal Systems',

  // Reseller
  MPS = 'MPS',
  DaaS = 'DaaS',
  PersonalSystemsSoftware = 'Personal Systems Software',
  General = 'General',
  LargeFormat = 'Large Format',

  // Retailer
  Retail = 'Retail',

  // Distributor
  Print = 'Print',
  PC = 'PC',
  LF = 'LF',
  Printing3D = '3D Printing',
  Supplies = 'Supplies',

  Summary = 'Summary', // Fake ProgramType
  None = '',

  Overall = 'Overall', // Fake ProgramType for the planning cockpit
  Consolidated = 'Consolidated', // Fake ProgramType for Global Partners
}
